import { Plural } from '@lingui/react/macro';
import React from 'react';

const Runtime: React.FC<{
  /**
   * In minutes
   */
  runtime: number;
}> = ({ runtime }) => {
  const hours = Math.floor(runtime / 60);
  const minutes = Math.floor(runtime % 60);
  const seconds = Math.floor((runtime % 1) * 60);
  return (
    <>
      <Plural value={hours} _0="" one="1 hour" other="# hours" /> <Plural value={minutes} _0="" one="1 minute" other="# minutes" />{' '}
      <Plural value={seconds} _0="" one="1 second" other="# seconds" />
    </>
  );
};

export default Runtime;
